module.exports = __webpack_public_path__ + "static/img/20020 (4).984f126.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20020 (4).webp
// module id = QsoT
// module chunks = 14